import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import Cookies from 'js-cookie'
import { displayDeployedTagOrCommit, Root } from 'app/entrypoint'
import { setupMetrics } from 'app/metrics'
import 'app/styles/index.css'
import 'app/styles/react-day-picker.css'
import { isNil } from 'shared/lib'

setupMetrics()
displayDeployedTagOrCommit()

const container = document.getElementById('root')!
const root = createRoot(container)

const originalRequest = Cookies.get('originalRequest')

if (!isNil(originalRequest)) {
  window.location.assign(originalRequest)
  Cookies.remove('originalRequest')
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 0, gcTime: 0, retry: false },
  },
})

root.render(
  <QueryClientProvider client={queryClient}>
    <Root />
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>,
)
